import { TextField, MenuItem, Chip } from "@mui/material";
import React, { useState, useEffect } from "react";

export default function AnswerQuestion({
  question,
  errors,
  handleChangeInputAnswer,
  answer,
  setAnswer,
}) {
  const [currentAnswer, setCurrentAnswer] = useState(null);

  // Lấy đáp án hiện tại khi câu hỏi thay đổi
  useEffect(() => {
    if (question?.question && answer) {
      setCurrentAnswer(answer[question.question] || null);
    }
  }, [question?.question, answer]);

  // Cập nhật đáp án vào answer object
  const updateAnswer = (newAnswerValue) => {
    if (!question?.question) return;

    const updatedAnswer = {
      ...answer,
      [question.question]: newAnswerValue,
    };
    setAnswer(updatedAnswer);
    setCurrentAnswer(newAnswerValue);
  };
  const handleAnswerQuestion = () => {
    switch (question?.type) {
      case "TN":
        return (
          <>
            {/* Nội dung đáp án */}
            <div className="space-y-6 mb-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">?</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Nội dung đáp án
                </h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Đáp án A
                  </label>
                  <TextField
                    fullWidth
                    name="contentAnswerA"
                    value={question?.contentAnswerA || ""}
                    onChange={handleChangeInputAnswer}
                    placeholder="Nhập nội dung đáp án A..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Đáp án B
                  </label>
                  <TextField
                    fullWidth
                    name="contentAnswerB"
                    value={question?.contentAnswerB || ""}
                    onChange={handleChangeInputAnswer}
                    placeholder="Nhập nội dung đáp án B..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Đáp án C
                  </label>
                  <TextField
                    fullWidth
                    name="contentAnswerC"
                    value={question?.contentAnswerC || ""}
                    onChange={handleChangeInputAnswer}
                    placeholder="Nhập nội dung đáp án C..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Đáp án D
                  </label>
                  <TextField
                    fullWidth
                    name="contentAnswerD"
                    value={question?.contentAnswerD || ""}
                    onChange={handleChangeInputAnswer}
                    placeholder="Nhập nội dung đáp án D..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Đáp án đúng */}
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 border border-blue-200">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">✓</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Đáp án đúng
                </h4>
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700">
                  Chọn đáp án đúng
                </label>
                <TextField
                  select
                  fullWidth
                  value={currentAnswer || ""}
                  onChange={(e) => updateAnswer(e.target.value)}
                  variant="outlined"
                  size="medium"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "white",
                      "&:hover fieldset": {
                        borderColor: "#3b82f6",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#3b82f6",
                      },
                    },
                  }}
                >
                  <MenuItem value="A">A</MenuItem>
                  <MenuItem value="B">B</MenuItem>
                  <MenuItem value="C">C</MenuItem>
                  <MenuItem value="D">D</MenuItem>
                </TextField>
              </div>
            </div>
          </>
        );
      case "DS":
        return (
          <>
            {/* Nội dung mệnh đề */}
            <div className="space-y-6 mb-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">?</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Nội dung mệnh đề
                </h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {["a", "b", "c", "d", "e", "f"].map((letter) => (
                  <div key={letter} className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">
                      Mệnh đề {letter})
                    </label>
                    <TextField
                      fullWidth
                      multiline
                      rows={2}
                      name={`contentY${letter.toUpperCase()}`}
                      value={
                        question?.[`contentY${letter.toUpperCase()}`] || ""
                      }
                      onChange={handleChangeInputAnswer}
                      placeholder={`Nhập nội dung mệnh đề ${letter}...`}
                      variant="outlined"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Đáp án đúng/sai */}
            <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-6 border border-orange-200">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-orange-500 to-red-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">✓</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Đáp án đúng/sai
                </h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {["a", "b", "c", "d"].map((letter) => (
                  <div key={letter} className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">
                      Mệnh đề {letter})
                    </label>
                    <TextField
                      select
                      fullWidth
                      value={(currentAnswer && currentAnswer[letter]) || ""}
                      onChange={(e) => {
                        const newAnswer = {
                          ...currentAnswer,
                          [letter]: e.target.value,
                        };
                        updateAnswer(newAnswer);
                      }}
                      variant="outlined"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    >
                      <MenuItem value="D">Đúng</MenuItem>
                      <MenuItem value="S">Sai</MenuItem>
                    </TextField>
                  </div>
                ))}
              </div>
            </div>
          </>
        );
      case "KT":
        return (
          <>
            {/* Nội dung kéo thả */}
            <div className="space-y-6 mb-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">?</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Nội dung kéo thả
                </h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {["A", "B", "C", "D", "E", "F", "G", "H"].map(
                  (letter, index) => (
                    <div key={letter} className="space-y-2">
                      <label className="text-sm font-semibold text-gray-700">
                        Kéo thả {letter}
                      </label>
                      <TextField
                        fullWidth
                        name={`${letter}>`}
                        value={question?.items?.[index]?.content || ""}
                        onChange={handleChangeInputAnswer}
                        placeholder={`Nhập nội dung kéo thả ${letter}...`}
                        variant="outlined"
                        size="medium"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            backgroundColor: "white",
                            "&:hover fieldset": {
                              borderColor: "#3b82f6",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3b82f6",
                            },
                          },
                        }}
                      />
                    </div>
                  )
                )}
              </div>
            </div>

            {/* Đáp án slot */}
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-6 border border-purple-200">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">✓</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Đáp án kéo thả
                </h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {[1, 2, 3, 4, 5, 6].map((slotNum) => {
                  if (!currentAnswer || !currentAnswer[`slot${slotNum}`])
                    return null;
                  return (
                    <div key={slotNum} className="space-y-2">
                      <label className="text-sm font-semibold text-gray-700">
                        Slot {slotNum}
                      </label>
                      <TextField
                        select
                        fullWidth
                        value={
                          (currentAnswer && currentAnswer[`slot${slotNum}`]) ||
                          ""
                        }
                        onChange={(e) => {
                          const newAnswer = {
                            ...currentAnswer,
                            [`slot${slotNum}`]: e.target.value,
                          };
                          updateAnswer(newAnswer);
                        }}
                        variant="outlined"
                        size="medium"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            backgroundColor: "white",
                            "&:hover fieldset": {
                              borderColor: "#3b82f6",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3b82f6",
                            },
                          },
                        }}
                      >
                        {["A>", "B>", "C>", "D>", "E>", "F>", "G>", "H>"].map(
                          (option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        );
      case "MA":
        return (
          <>
            {/* Nội dung checkbox */}
            <div className="space-y-6 mb-6">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">?</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Nội dung đáp án
                </h4>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[1, 2, 3, 4, 5, 6].map((num) => (
                  <div key={num} className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">
                      Đáp án Checkbox {num}
                    </label>
                    <TextField
                      fullWidth
                      name={`contentC${num}`}
                      value={question?.[`contentC${num}`] || ""}
                      onChange={handleChangeInputAnswer}
                      placeholder={`Nhập nội dung đáp án ${num}...`}
                      variant="outlined"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Đáp án checkbox đúng */}
            <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 border border-indigo-200">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">✓</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Đáp án đúng
                </h4>
                <p className="text-sm text-gray-600">
                  (Chọn nhiều đáp án đúng)
                </p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {["c1", "c2", "c3", "c4", "c5", "c6", "c7", "c8"].map(
                  (option) => (
                    <div key={option} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        id={option}
                        checked={
                          (currentAnswer &&
                            Array.isArray(currentAnswer) &&
                            currentAnswer.includes(option)) ||
                          false
                        }
                        onChange={(e) => {
                          let newAnswer =
                            currentAnswer && Array.isArray(currentAnswer)
                              ? [...currentAnswer]
                              : [];
                          if (e.target.checked) {
                            if (!newAnswer.includes(option)) {
                              newAnswer.push(option);
                            }
                          } else {
                            newAnswer = newAnswer.filter(
                              (item) => item !== option
                            );
                          }
                          updateAnswer(newAnswer);
                        }}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <label
                        htmlFor={option}
                        className="text-sm font-medium text-gray-700"
                      >
                        {option.toUpperCase()}
                      </label>
                    </div>
                  )
                )}
              </div>

              {currentAnswer &&
                Array.isArray(currentAnswer) &&
                currentAnswer.length > 0 && (
                  <div className="mt-4 p-3 bg-white rounded-lg border">
                    <p className="text-sm text-gray-600 mb-2">
                      Đáp án đã chọn:
                    </p>
                    <div className="flex flex-wrap gap-2">
                      {currentAnswer.map((item, index) => (
                        <Chip
                          key={index}
                          label={item.toUpperCase()}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      ))}
                    </div>
                  </div>
                )}
            </div>
          </>
        );
      case "TLN_M":
        return (
          <>
            {/* Đáp án số nhiều ý */}
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-200">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-xs font-bold">Aa</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Đáp án nhiều ý
                </h4>
                <p className="text-sm text-gray-600">
                  (Nhập đáp án text hoặc số cho từng ý)
                </p>
              </div>

              <div className="space-y-4">
                {/* Hiển thị các ý hiện có */}
                {currentAnswer &&
                typeof currentAnswer === "object" &&
                !Array.isArray(currentAnswer) ? (
                  Object.entries(currentAnswer).map(([key, values]) => (
                    <div
                      key={key}
                      className="bg-white rounded-lg p-4 border border-gray-200"
                    >
                      <div className="flex items-center justify-between mb-3">
                        <label className="text-sm font-semibold text-gray-700">
                          Ý {key}
                        </label>
                        <button
                          onClick={() => {
                            const newAnswer = { ...currentAnswer };
                            delete newAnswer[key];
                            updateAnswer(
                              Object.keys(newAnswer).length > 0 ? newAnswer : {}
                            );
                          }}
                          className="text-red-500 hover:text-red-700 text-xs bg-red-50 hover:bg-red-100 px-2 py-1 rounded"
                        >
                          Xóa ý
                        </button>
                      </div>

                      <div className="space-y-2">
                        {/* Hiển thị các giá trị của ý này */}
                        {Array.isArray(values) &&
                          values.map((value, valueIndex) => (
                            <div
                              key={valueIndex}
                              className="flex items-center space-x-2"
                            >
                              <TextField
                                fullWidth
                                value={value || ""}
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  const newValues = [...values];
                                  newValues[valueIndex] = newValue;
                                  const newAnswer = {
                                    ...currentAnswer,
                                    [key]: newValues,
                                  };
                                  updateAnswer(newAnswer);
                                }}
                                placeholder="Nhập giá trị (text hoặc số)..."
                                variant="outlined"
                                size="small"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    backgroundColor: "white",
                                    "&:hover fieldset": {
                                      borderColor: "#3b82f6",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#3b82f6",
                                    },
                                  },
                                }}
                              />
                              <button
                                onClick={() => {
                                  const newValues = values.filter(
                                    (_, i) => i !== valueIndex
                                  );
                                  const newAnswer = {
                                    ...currentAnswer,
                                    [key]:
                                      newValues.length > 0 ? newValues : [""],
                                  };
                                  updateAnswer(newAnswer);
                                }}
                                className="text-red-500 hover:text-red-700 bg-red-50 hover:bg-red-100 p-1 rounded"
                              >
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              </button>
                            </div>
                          ))}

                        {/* Nút thêm giá trị mới cho ý này */}
                        <button
                          onClick={() => {
                            const newValues = Array.isArray(values)
                              ? [...values, ""]
                              : [""];
                            const newAnswer = {
                              ...currentAnswer,
                              [key]: newValues,
                            };
                            updateAnswer(newAnswer);
                          }}
                          className="text-blue-600 hover:text-blue-800 text-xs bg-blue-50 hover:bg-blue-100 px-3 py-1 rounded flex items-center space-x-1"
                        >
                          <svg
                            className="w-3 h-3"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                            />
                          </svg>
                          <span>Thêm giá trị</span>
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-4 text-gray-500">
                    Chưa có ý nào. Hãy thêm ý đầu tiên.
                  </div>
                )}

                {/* Nút thêm ý mới */}
                <div className="flex justify-center">
                  <button
                    onClick={() => {
                      const currentKeys =
                        currentAnswer &&
                        typeof currentAnswer === "object" &&
                        !Array.isArray(currentAnswer)
                          ? Object.keys(currentAnswer)
                          : [];

                      // Tìm số ý tiếp theo
                      let nextNumber = 1;
                      while (currentKeys.includes(`${nextNumber}.`)) {
                        nextNumber++;
                      }

                      const newAnswer = {
                        ...currentAnswer,
                        [`${nextNumber}.`]: [""],
                      };
                      updateAnswer(newAnswer);
                    }}
                    className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white px-4 py-2 rounded-lg font-medium text-sm flex items-center space-x-2 shadow-lg transform hover:scale-105 transition-all duration-200"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                      />
                    </svg>
                    <span>Thêm ý mới</span>
                  </button>
                </div>

                <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
                  <p className="text-xs text-blue-700">
                    <strong>Lưu ý:</strong> Đáp án sẽ được lưu dưới dạng object
                    với key là "1.", "2.", "3."... và value là mảng text hoặc
                    số.
                    <br />
                    <strong>Ví dụ số:</strong> {"{"}"1.": [1, 2], "2.": [3]{"}"}
                    <br />
                    <strong>Ví dụ text:</strong> {"{"}"1.": ["glucose"], "2.":
                    ["kênh protein"]{"}"}
                  </p>
                </div>
              </div>
            </div>
          </>
        );
      case "TLN":
        return (
          <>
            {/* Đáp án text */}
            <div className="bg-gradient-to-r from-cyan-50 to-blue-50 rounded-2xl p-6 border border-cyan-200">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-6 h-6 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-sm font-bold">T</span>
                </div>
                <h4 className="text-lg font-semibold text-gray-800">
                  Đáp án text
                </h4>
                <p className="text-sm text-gray-600">
                  (Nhập text hoặc chọn A, B, C, D)
                </p>
              </div>

              <div className="space-y-4">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Loại đáp án
                  </label>
                  <TextField
                    select
                    fullWidth
                    value={
                      typeof currentAnswer === "string" ? "text" : "number"
                    }
                    onChange={(e) => {
                      if (e.target.value === "text") {
                        updateAnswer("");
                      } else {
                        updateAnswer([0]);
                      }
                    }}
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  >
                    <MenuItem value="text">Text/Chữ cái (A, B, C, D)</MenuItem>
                    <MenuItem value="number">Số (trong mảng)</MenuItem>
                  </TextField>
                </div>

                {typeof currentAnswer === "string" ? (
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">
                      Đáp án text
                    </label>
                    <TextField
                      fullWidth
                      value={currentAnswer || ""}
                      onChange={(e) => updateAnswer(e.target.value)}
                      placeholder="Nhập đáp án (VD: A, B, C, D hoặc text khác)..."
                      variant="outlined"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    />
                  </div>
                ) : (
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-gray-700">
                      Đáp án số
                    </label>
                    <TextField
                      fullWidth
                      type="number"
                      value={
                        (currentAnswer &&
                          Array.isArray(currentAnswer) &&
                          currentAnswer[0]) ||
                        ""
                      }
                      onChange={(e) => {
                        const value = parseFloat(e.target.value);
                        updateAnswer([isNaN(value) ? 0 : value]);
                      }}
                      placeholder="Nhập giá trị số..."
                      variant="outlined"
                      size="medium"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };
  return handleAnswerQuestion();
}
